import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage, injectIntl, dangerouslySetInnerHTML } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import SchoolDataSimple from '../SchoolDataSimple';
import SchoolInfoItem from '../SchoolInfoItem';
import { withRtl } from '../hoc';
import style from './SchoolInfo.scss';
import messages from '../../locale/messages';
import analytics from '../../services/analytics';
import { isK, isSR, customisedIntlFormatMessage } from '../../utils/helpers';
import MapPinIcon from '../icons/MapPin';
import CardCurrentSchoolInteriorCardIcon from '../icons/CardCurrentSchoolInteriorCard';
import CursorIcon from '../icons/Cursor';
import EmailIcon from '../icons/Email';
import PhoneIcon from '../icons/Phone';
import MortarboardIcon from '../icons/Mortarboard';
import StudentsIcon from '../icons/Students';
import TimeIcon from '../icons/Time';
import SpecialEducationAndELLIcon from '../icons/SpecialEducationAndELL';
import SubwayIcon from '../icons/Subway';
import BusIcon from '../icons/Bus';
import LightBulbIcon from '../icons/LightBulb';
import SchoolEvents from '../SchoolEvents';

const localMessages = defineMessages({
  overviewTitle: {
    id: 'schoolinfo.overview.title',
    defaultMessage: 'Overview',
    description: 'Overview of school',
  },
  less: {
    id: 'schoolinfo.overview.less',
    defaultMessage: 'Show less',
    description: 'Show less text',
  },
  schoolWebsite: {
    id: 'schoolinfo.schoolWebsite',
    defaultMessage: 'School website',
    description: 'School website',
  },
  schoolEmail: {
    id: 'schoolinfo.schoolEmail',
    defaultMessage: 'School email',
    description: 'School email',
  },
  schoolPhone: {
    id: 'schoolinfo.schoolPhone',
    defaultMessage: 'School phone',
    description: 'School phone',
  },
  schoolAddress: {
    id: 'schoolinfo.schoolAddress',
    defaultMessage: 'School address, opens in new window',
    description: 'School address',
  },
  accordionPerformance: {
    id: 'schoolinfo.accordionPerformance',
    defaultMessage: 'Performance',
    description: 'Accordion label for school performance',
  },
  accordionAcademics: {
    id: 'schoolinfo.accordionAcademics',
    defaultMessage: 'Academics',
    description: 'Accordion label for school Academics',
  },
  accordionActivities: {
    id: 'schoolinfo.accordionActivities',
    defaultMessage: 'Activities',
    description: 'Accordion label for school Activities',
  },
  accordionOtherFeatures: {
    id: 'schoolinfo.accordionOtherFeatures',
    defaultMessage: 'Other Features',
    description: 'Accordion label for school Other Features',
  },
  accordionAffiliatedSchools: {
    id: 'schoolinfo.accordionAffiliatedSchools',
    defaultMessage: 'Affiliated Schools',
    description: 'Accordion label for school Affiliated Schools',
  },
  accordionAccessibility: {
    id: 'schoolinfo.accordionAccessibility',
    defaultMessage: 'Accessibility',
    description: 'Accordion label for school Accessibility',
  },
  accordionOpenHouses: {
    id: 'schoolinfo.accordionOpenHouses',
    defaultMessage: 'Open Houses & Information Sessions',
    description: 'Accordion label for school Open Houses & Information Sessions',
  },
  accordionMoreInfo: {
    id: 'schoolinfo.accordionMoreInfo',
    defaultMessage: 'More Info',
    description: 'More Info',
  },
  schoolDataSharedSpace: {
    id: 'schoolinfo.sharedSpace',
    defaultMessage: 'Shared Space: {sharedSpace}',
    description: `String declaring if a school does or doesn't share space with another`,
    values: {
      sharedSpace: 'No',
    },
  },
  schoolDataELLPrograms: {
    id: 'schoolinfo.schoolDataELLPrograms',
    defaultMessage: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
    description: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
  },
  schoolDataLangaugeCourses: {
    id: 'schoolinfo.schoolDataLangaugeCourses',
    defaultMessage: 'LANGUAGE COURSES',
    description: 'LANGUAGE COURSES',
  },
  schoolDataAPCourses: {
    id: 'schoolinfo.schoolDataAPCourses',
    defaultMessage: 'ADVANCED PLACEMENT (AP) COURSES',
    description: 'ADVANCED PLACEMENT (AP) COURSES',
  },
  schoolDataAdvancedCourses: {
    id: 'schoolinfo.schoolDataAdvancedCourses',
    defaultMessage: 'ADVANCED COURSES',
    description: 'ADVANCED COURSES',
  },
  schoolDataDiplomaEndorsements: {
    id: 'schoolinfo.schoolDataDiplomaEndorsements',
    defaultMessage: 'DIPLOMA ENDORSEMENTS',
    description: 'DIPLOMA ENDORSEMENTS',
  },
  schoolDataSports: {
    id: 'schoolinfo.schoolDataSports',
    defaultMessage: 'SCHOOL SPORTS',
    description: 'SCHOOL SPORTS',
  },
  schoolDataSportsCoed: {
    id: 'schoolinfo.schoolDataSportsCoed',
    defaultMessage: 'PSAL SPORTS - COED',
    description: 'PSAL SPORTS - COED',
  },
  schoolDataSportsGirls: {
    id: 'schoolinfo.schoolDataSportsGirls',
    defaultMessage: 'PSAL SPORTS - GIRLS',
    description: 'PSAL SPORTS - GIRLS',
  },
  schoolDataSportsBoys: {
    id: 'schoolinfo.schoolDataSportsBoys',
    defaultMessage: 'PSAL SPORTS - BOYS',
    description: 'PSAL SPORTS - BOYS',
  },
  schoolStatsGraduate: {
    id: 'schoolinfo.schoolStatsGraduate',
    defaultMessage: 'of students graduate in four years',
    description: 'percentage of students of graduate. A percent precedes this string (ie 76%) ',
  },
  schoolStatsEnrollCollege: {
    id: 'schoolinfo.schoolStatsEnrollCollege',
    defaultMessage: 'of students enroll in college or career programs',
    description:
      'percentage of students of enroll in college or career programs. A percent precedes this string (ie 76%) ',
  },
  schoolStatsAttendance: {
    id: 'schoolinfo.schoolStatsAttendance',
    defaultMessage: 'student attendance',
    description: 'percentage of student attendance. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSaftey: {
    id: 'schoolinfo.schoolStatsSaftey',
    defaultMessage: 'of students feel safe in the hallways, bathrooms, locker room, and cafeteria',
    description: 'percentage of students who feel safe. A percent precedes this string (ie 76%) ',
  },
  schoolStatsVariety: {
    id: 'schoolinfo.schoolStatsVariety',
    defaultMessage:
      'of students feel that this school offers a wide enough variety of programs, classes, and activities to keep them interested in school',
    description:
      'percentage of student who like the variety the school offers. A percent precedes this string (ie 76%) ',
  },
  schoolStatsCoreCourses: {
    id: 'schoolinfo.schoolStatsCoreCourses',
    defaultMessage: 'of students passed core courses',
    description: 'percentage of students who passed core courses. A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateEla: {
    id: 'schoolinfo.schoolStatsStateEla',
    defaultMessage: 'of students scored at Level 3 or 4 on the State English Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State English Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  schoolStatsStateMath: {
    id: 'schoolinfo.schoolStatsStateMath',
    defaultMessage: 'of students scored at Level 3 or 4 on the State Math Test',
    description:
      'percentage of students who of students scored at Level 3 or 4 on the State Math Test. ' +
      'A percent precedes this string (ie 76%) ',
  },
  middleSchoolDataSports: {
    id: 'schoolinfo.middleSchoolDataSports',
    defaultMessage: 'CHAMPS SPORTS',
    description: 'CHAMPS SPORTS',
  },
  middleSchoolDataSportsCoed: {
    id: 'schoolinfo.middleSchoolDataSportsCoed',
    defaultMessage: 'CHAMPS SPORTS - COED',
    description: 'CHAMPS SPORTS - COED',
  },
  middleSchoolDataSportsGirls: {
    id: 'schoolinfo.middleSchoolDataSportsGirls',
    defaultMessage: 'CHAMPS SPORTS - GIRLS',
    description: 'CHAMPS SPORTS - GIRLS',
  },
  middleSchoolDataSportsBoys: {
    id: 'schoolinfo.middleSchoolDataSportsBoys',
    defaultMessage: 'CHAMPS SPORTS - BOYS',
    description: 'CHAMPS SPORTS - BOYS',
  },
  middleSchoolAcceleratedClasses: {
    id: 'schoolinfo.middleSchoolAcceleratedClasses',
    defaultMessage: 'ACCELERATED CLASSES',
    description: 'ACCELERATED CLASSES',
  },
  // frequentlyAttendedHighSchools: {
  //   id: 'schoolinfo.frequentlyAttendedHighSchools',
  //   defaultMessage: 'High schools most frequently attended by students from this school',
  //   description: 'High schools most frequently attended by students from this school',
  // },
  kindergartenSpecialEducationPrograms: {
    id: 'schoolinfo.kindergartenSpecialPrograms',
    defaultMessage: 'Special Education Programs',
    description: 'Kindergarten students Special Education Programs',
  },
  kindergartenELLPrograms: {
    id: 'schoolinfo.kindergartenELLPrograms',
    defaultMessage: 'English Language Learner Programs',
    description: 'Kindergarten students English Language Learner Programs',
  },
});

class SchoolInfo extends PureComponent {
  static defaultProps = {
    address: '',
    bus: '',
    email: '',
    grades: '',
    hours: '',
    overview: '',
    phone: '',
    studentCount: '',
    subway: '',
    website: '',
    otherFeatures: [],
    affiliatedSchools: [],
    loggedIn: false,
  };
  static propTypes = {
    academics: PropTypes.shape({
      ell: PropTypes.arrayOf(PropTypes.shape({})),
      languageClasses: PropTypes.arrayOf(PropTypes.shape({})),
      apCourses: PropTypes.arrayOf(PropTypes.shape({})),
      diplomaEndorsements: PropTypes.arrayOf(PropTypes.shape({})),
      electivesDescription: PropTypes.string,
      opportunities: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    accessibility: PropTypes.string.isRequired,
    activities: PropTypes.shape({
      activities: PropTypes.arrayOf(PropTypes.shape({})),
      sportsBoys: PropTypes.arrayOf(PropTypes.shape({})),
      sportsCoed: PropTypes.arrayOf(PropTypes.shape({})),
      sportsGirls: PropTypes.arrayOf(PropTypes.shape({})),
      sportsSchool: PropTypes.arrayOf(PropTypes.shape({})),
      activitiesDescription: PropTypes.string,
    }).isRequired,
    address: PropTypes.string,
    bus: PropTypes.string,
    contactName: PropTypes.string.isRequired,
    admissionsOpen: PropTypes.string,
    waitlistOpen: PropTypes.string,
    resultsEnabled: PropTypes.string,
    school: PropTypes.shape({
      dbn: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    diversityInAdmissions: PropTypes.string.isRequired,
    email: PropTypes.string,
    loggedIn: PropTypes.bool,
    grades: PropTypes.string,
    hours: PropTypes.string,
    id: PropTypes.number.isRequired,
    openHouses: PropTypes.string.isRequired,
    overview: PropTypes.string,
    // TODO: Bring Calendar events from API
    // events: PropTypes.arrayOf(
    //   PropTypes.shape({
    //     title: PropTypes.string,
    //   }),
    // ),
    performance: PropTypes.shape({}).isRequired,
    phone: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      }),
    ).isRequired,
    sharedSpace: PropTypes.bool.isRequired,
    studentCount: PropTypes.string,
    subway: PropTypes.string,
    website: PropTypes.string,
    intl: PropTypes.shape().isRequired,
    otherFeatures: PropTypes.arrayOf(PropTypes.shape({})),
    affiliatedSchools: PropTypes.arrayOf(PropTypes.shape({})),
    user: PropTypes.shape({}).isRequired,
    admissionProcess: PropTypes.string.isRequired,
  };

  getAcademicOpportunities = () => {
    const { academics } = this.props;
    const academicsList = academics.opportunities.map(academicItem => (
      <li key={academicItem.name}>{academicItem.name}</li>
    ));
    return <ul className={style.disc}>{academicsList}</ul>;
  };

  getOtherInfo = (listItems, title) => {
    if (!listItems || listItems.length === 0) {
      return null;
    }
    const itemList = listItems.map(item => item.name);
    const last = itemList.pop();
    let itemContents = '';
    if (itemList.length > 1) {
      itemContents = `${itemList.join(', ')} and ${last}`;
    } else if (itemList.length === 1) {
      itemContents = `${itemList[0]} and ${last}`;
    } else if (last) {
      itemContents = last;
    } else {
      return null;
    }
    return <SchoolDataSimple title={title} stat={itemContents} />;
  };

  getTextInformation = (text, title) => {
    if (text) {
      return <SchoolDataSimple title={title} stat={text} />;
    }
    return null;
  };

  getFrequentlyAttendedHS = (listItems, title) => {
    const { id } = this.props;
    if (listItems && listItems.length > 0) {
      return (
        <div>
          <span className={style.frequentHSTitle}>{title}</span>
          <ul className={style.disc}>
            {listItems.map(item => (
              <li key={`${id}-${item}`}>{item}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  getOtherFeatures = () => {
    const { otherFeatures } = this.props;
    const otherFeaturesList = otherFeatures.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{otherFeaturesList}</ul>;
  };

  getAffiliatedSchools = () => {
    const { affiliatedSchools } = this.props;
    const affiliatedSchoolsList = affiliatedSchools.map(item => <li key={item}>{item}</li>);
    return <ul className={style.disc}>{affiliatedSchoolsList}</ul>;
  };

  getStatDisplay = (statistic, displayString) => {
    if (!statistic) {
      return null;
    }
    return (
      <li>
        <span className={style.stat}>{statistic}%</span> {displayString}
      </li>
    );
  };

  accordionClick = accordionLabel => {
    const { school, loggedIn } = this.props;
    analytics({
      eventLabel: 'schoolAccordionOpen',
      dataDictionary: {
        accordionLabel,
        schoolDbn: `${school.dbn}`,
        schoolName: `${school.name}`,
        loggedIn
      },
    });
  };

  /* eslint-disable react/no-danger */
  render() {
    const {
      address,
      bus,
      email,
      grades,
      hours,
      overview,
      phone,
      // sections,
      subway,
      studentCount,
      website,
      intl,
      diversityInAdmissions,
      contactName,
      user,
      sharedSpace,
      admissionProcess,
      showDetails,
    } = this.props;

    const spaceSharedText = sharedSpace
      ? `${customisedIntlFormatMessage(intl, messages.generalStringYes)}`
      : `${customisedIntlFormatMessage(intl, messages.generalStringNo)}`;
    let userLoggedIn = false;
    if (user && user.guardianId) {
      userLoggedIn = true;
    }
    let schoolWebsite = website;
    if (website && website.indexOf('http://') === -1 && website.indexOf('https://') === -1) {
      schoolWebsite = `http://${website}`;
    }
    const isKProcess = isK({ user }) || admissionProcess === 'K';
    const isSRProcess = isSR({ user }) || admissionProcess === 'SR';
    const showContactDetails = (isSRProcess && (subway || bus));
    const sanitized_email = sanitize_html(email);
    const sanitized_address = sanitize_html(address);
    const sanitized_schoolWebsite = sanitize_html(schoolWebsite);

    return (
      <div className={style.root}>
        {address && <div className={style.address}>
          <SchoolInfoItem
            icon={
              <MapPinIcon
                //
                size={18}
                ariaLabel={customisedIntlFormatMessage(intl, messages.iconMapPin)}
              />
            }
          >
            <a
              target="_blank"
              rel="noopener"
              href={`https://www.google.com/maps?q=${sanitized_address}`}
              aria-label={customisedIntlFormatMessage(intl, localMessages.schoolAddress)}
            >
              <span dir="ltr">{address}</span>
            </a>
          </SchoolInfoItem>
        </div>} 
        {(!isSRProcess && (schoolWebsite || email || phone || contactName || grades || studentCount || hours || isKProcess || subway || bus)) && (
          <div className={style.info}>
            {(schoolWebsite || email || phone || contactName || grades || studentCount || hours || isKProcess) && 
              <div className={style.col}>
              {(schoolWebsite || email || phone || contactName) && <div className={style.row}>
                {schoolWebsite && (
                  <SchoolInfoItem
                    icon={
                      <CursorIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconCursor)}
                      />
                    }
                  >
                    <a
                      target="_blank"
                      className={style.schoolLink}
                      rel="noopener"
                      href={`${sanitized_schoolWebsite}`}
                      aria-label={customisedIntlFormatMessage(intl, localMessages.schoolWebsite)}
                    >
                      {website}
                    </a>
                  </SchoolInfoItem>
                )}
                {email && (
                  <SchoolInfoItem
                    icon={
                      <EmailIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconEmail)}
                      />
                    }
                  >
                    <a href={`mailto:${sanitized_email}`} aria-label={customisedIntlFormatMessage(intl, localMessages.schoolEmail)}>
                      {email}
                    </a>
                  </SchoolInfoItem>
                )}
                {phone && (
                  <SchoolInfoItem
                    icon={
                      <PhoneIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconPhone)}
                      />
                    }
                  >
                    <a href={`tel:${phone}`} aria-label={customisedIntlFormatMessage(intl, localMessages.schoolPhone)}>
                      {phone}
                    </a>
                  </SchoolInfoItem>
                )}
                {contactName && (
                  <SchoolInfoItem
                    icon={
                      <LightBulbIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconContactName)}
                      />
                    }
                  >
                    <div dangerouslySetInnerHTML={{ __html: contactName }}></div>
                  </SchoolInfoItem>
                )}
              </div>}
              {(grades || studentCount || hours || isKProcess) && <div className={style.row}>
                {grades && (
                  <SchoolInfoItem
                    icon={
                      <MortarboardIcon
                        //
                        ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringGradeRange)}
                        size={18}
                      />
                    }
                  >
                    {grades}
                  </SchoolInfoItem>
                )}
                {studentCount && (
                  <SchoolInfoItem
                    icon={
                      <StudentsIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconStudents)}
                      />
                    }
                  >
                    {studentCount}
                  </SchoolInfoItem>
                )}
                {hours && (
                  <SchoolInfoItem
                    icon={
                      <TimeIcon
                        //
                        size={18}
                        ariaLabel={customisedIntlFormatMessage(intl, messages.iconTime)}
                      />
                    }
                  >
                    {hours}
                  </SchoolInfoItem>
                )}
                {isKProcess && (
                  <Fragment>
                    <SchoolInfoItem
                      icon={
                        <SpecialEducationAndELLIcon
                          //
                          size={18}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.iconTime)}
                        />
                      }
                    >
                      <div>
                        <FormattedMessage {...localMessages.kindergartenSpecialEducationPrograms} />
                      </div>
                      <div>
                        <FormattedMessage {...localMessages.kindergartenELLPrograms} />
                      </div>
                    </SchoolInfoItem>
                    <SchoolInfoItem
                      icon={
                        <CardCurrentSchoolInteriorCardIcon
                          //
                          fill="#000"
                          size={20}
                          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramCurrentSchoolIconMessageK)}
                        />
                      }
                    >
                      <div>
                        <FormattedMessage
                          {...localMessages.schoolDataSharedSpace}
                          values={{ sharedSpace: spaceSharedText }}
                        />
                      </div>
                    </SchoolInfoItem>
                  </Fragment>
                )}
              </div>}
            </div>}
            {(subway || bus) && <div className={style.col}>
              {subway && (
                <SchoolInfoItem
                  icon={
                    <SubwayIcon
                      //
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconSubway)}
                    />
                  }
                >
                  <strong>{customisedIntlFormatMessage(intl, messages.iconSubway)}</strong>
                  <br />
                  {subway}
                </SchoolInfoItem>
              )}
              {bus && (
                <SchoolInfoItem
                  icon={
                    <BusIcon
                      //
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconBus)}
                    />
                  }
                >
                  <strong>{customisedIntlFormatMessage(intl, messages.iconBus)}</strong>
                  <br />
                  {bus}
                </SchoolInfoItem>
              )}
            </div>}
          </div>)}
        {(showContactDetails && (subway || bus)) && (
          <div className={style.info}>
            <div className={style.rowWithSingleChild}>
              {subway && (
                <SchoolInfoItem
                  icon={
                    <SubwayIcon
                      //
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconSubway)}
                    />
                  }
                >
                  <strong>{customisedIntlFormatMessage(intl, messages.iconSubway)}</strong>
                  <br />
                  {subway}
                </SchoolInfoItem>
              )}
              {bus && (
                <SchoolInfoItem
                  icon={
                    <BusIcon
                      //
                      size={18}
                      ariaLabel={customisedIntlFormatMessage(intl, messages.iconBus)}
                    />
                  }
                >
                  <strong>{customisedIntlFormatMessage(intl, messages.iconBus)}</strong>
                  <br />
                  {bus}
                </SchoolInfoItem>
              )}
            </div>
          </div>)}
        {!isSRProcess && showDetails && <SchoolEvents
          {...this.props.info}
          page={'directory'}
          dbn={this.props.school.dbn}
          school={this.props.school}
          overview={this.props.overview}
          admissionProcess={this.props.admissionProcess}
        />}
        {!isSRProcess && overview && overview.length ? (
          <div className={style.overview}>
            <h3 className={style.sectionTitle}>{customisedIntlFormatMessage(intl, localMessages.overviewTitle)}</h3>
            <p className={style.overviewText}>{overview}</p>
            {diversityInAdmissions && <p className={style.overviewText}>{diversityInAdmissions}</p>}
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

// export { SchoolInfo };
export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(SchoolInfo);
